import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { TitleRoutingModule } from './title-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, SharedModule, TitleRoutingModule],
})
export class TitleModule {}
